import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Ladder } from '../../../models/ladder.model';
import { Level } from '../../../models/level.model';
import { Score } from '../../../models/score.model';
import { DownloadService } from '../../../services/download.service';

@Component({
  selector: 'admin-print-player-list',
  templateUrl: './printplayerlist.component.html',
  styleUrls: ['./printplayerlist.component.scss']
})
export class AdminPrintPlayerListComponent implements OnInit {
  public ladders: Ladder[] = [];
  public ladder: string;

  constructor(private http: HttpClient, private fb: FormBuilder, private downloadSvc: DownloadService) {
  }

  ngOnInit() {
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders.length = 0;
        for (const l of resp) {
          this.ladders.push(new Ladder(l));
        }
      }
    )
  }

  public async doit(evt) {
    const h = new HttpHeaders();
    const response = await this.http.get(`/admin/printplayerlist?ladderId=${this.ladder}`, { headers: h, responseType: 'blob', observe: 'response' }).toPromise();
    if (response.body) {
      var fileName: string = "abc.doc";
      var contentDisposition = response.headers.get("Content-Disposition");
      if (contentDisposition) {
        var found = contentDisposition.match(/.+filename=["]?([^"]*)["]?;.*/);
        if (found && found.length > 1) {
          fileName = found[1];
        }
      }
      var fileType: string = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      this.downloadSvc.Download(response.body, fileType, fileName);
    }
  }

}
